import PropTypes from 'prop-types';
import './styles.scss';
import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reminderMessage } from '../../constants/example-gallery-popup';
import {
  selectEmbeddingMainType,
  selectEmbeddingFullType,
} from '../../store/OperationsMenu/selectors';
import { dossierUrlRegExp, libraryUrlRegExp } from '../../constants/urls-regexp';
import {
  setIsOpen as setIsOpenAction,
  updateEnvironment as updateEnvironmentAction,
  updateUrl as updateUrlAction,
  updateUsername as updateUsernameAction,
  updatePassword as updatePasswordAction,
  updateContentGroup as updateContentGroupAction,
} from '../../store/EnvironmentSetting/actions';
import {
  selectIsOpen,
  selectCustomUrl,
  selectContentGroup,
  selectUserName,
  selectPassword,
} from '../../store/EnvironmentSetting/selectors';
import { CLICK_PLAYGROUND_USER_MANUAL_LINK } from '../../constants/google-analytics';
import { sendGAEvent } from '../../store/GoogleAnalytics/actions';
import EmbeddingType from '../../utils/embeddingType';

const EnvironmentSetting = ({
  isOpen,
  embeddingType,
  embeddingFullType,
  setIsOpen,
  updateEnvironment,
  onSendGAEvent,
  customUrl,
  contentGroup,
  username,
  password,
  updateUrl,
  updateContentGroup,
  updateUsername,
  updatePassword,
}) => {
  const activeBtn = 'button';
  const inactiveBtn = 'button-disabled';
  const activeError = 'error-message__open';
  const inactiveError = 'error-message__closed';
  const dashboardRegexErrorMessage = `Dashboard URL must be in the form: 'https://{env-url}/{libraryName}/app/{projectId}/{dashboardId}' 
or 'https://{env-url}/{libraryName}/app/config/{configId}/{projectId}/{dashboardId}'`;
  const libraryRegexErrorMessage = `Library URL must be in the form: 'https://{env-url}/{libraryName}' 
or 'https://{env-url}/{libraryName}/app/config/{configId}`;
  const botRegexErrorMessage = `Bot URL must be in the form: 'https://{env-url}/{libraryName}/app/{projectId}/{botId}' 
or 'https://{env-url}/{libraryName}/app/config/{configId}/{projectId}/{botId}'`;

  const errorMessageMap = {
    [EmbeddingType.Dashboard]: dashboardRegexErrorMessage,
    [EmbeddingType.Library]: libraryRegexErrorMessage,
    [EmbeddingType.Bot]: botRegexErrorMessage,
    [EmbeddingType.Bot_Api]: botRegexErrorMessage,
    [EmbeddingType.Bot_Auto]: libraryRegexErrorMessage,
    [EmbeddingType.Bot_AutoImage]: libraryRegexErrorMessage,
    [EmbeddingType.NextGet_AI]: botRegexErrorMessage,
    [EmbeddingType.Visualization]: dashboardRegexErrorMessage,
  };

  const placeholderMap = {
    [EmbeddingType.Dashboard]:
      'e.g. `https://{env-url}/{libraryName}/app/{projectId}/{dashboardId}`',
    [EmbeddingType.Library]: 'e.g. `https://{env-url}/{libraryName}`',
    [EmbeddingType.Bot]: 'e.g. `https://{env-url}/{libraryName}/app/{projectId}/{botId}`',
    [EmbeddingType.Bot_Api]: 'e.g. `https://{env-url}/{libraryName}/app/{projectId}/{botId}`',
    [EmbeddingType.Bot_Auto]: 'e.g. `https://{env-url}/{libraryName}`',
    [EmbeddingType.Bot_AutoImage]: 'e.g. `https://{env-url}/{libraryName}`',
    [EmbeddingType.NextGet_AI]: 'e.g. `https://{env-url}/{libraryName}/app/{projectId}/{botId}`',
    [EmbeddingType.Visualization]:
      'e.g. `https://{env-url}/{libraryName}/app/{projectId}/{dashboardId}`',
  };

  const [err, setErr] = useState(inactiveError);
  const [btn, setBtn] = useState(inactiveBtn);
  const [errorMessage, setErrorMessage] = useState('');

  const checkValidUrl = (url) => {
    if (
      [EmbeddingType.Library, EmbeddingType.Bot_AutoImage, EmbeddingType.Bot_Auto].includes(
        embeddingFullType,
      )
    ) {
      return libraryUrlRegExp.test(url);
    }
    return dossierUrlRegExp.test(url);
  };

  const getEmbeddingDisplay = () => {
    if (embeddingFullType === EmbeddingType.Visualization) {
      return EmbeddingType.Dashboard;
    }
    if ([EmbeddingType.Bot_Auto, EmbeddingType.Bot_AutoImage].includes(embeddingFullType)) {
      return EmbeddingType.Library;
    }
    return embeddingType;
  };

  const setUsernamePassword = () => {
    return (
      <>
        <div className="setting-items">
          <div className="item-name">Your Username</div>
          <input
            type="text"
            id="url"
            className="url-input"
            tabIndex="0"
            placeholder="Your Username"
            value={username}
            onChange={(e) => {
              updateUsername(e.target.value);
            }}
          />
        </div>
        <div className="setting-items">
          <div className="item-name">Your Password</div>
          <input
            type="password"
            id="url"
            className="url-input"
            tabIndex="0"
            placeholder="Your Password"
            value={password}
            onChange={(e) => {
              updatePassword(e.target.value);
            }}
          />
        </div>
      </>
    );
  };

  const setContentGround = () => {
    return (
      <div className="setting-items">
        <div className="item-name">Content Group Id</div>
        <input
          type="text"
          id="content-group"
          className="url-input"
          tabIndex="0"
          placeholder="e.g.75A330687C4E2520BA5819BB9476A387 (Optional)"
          value={contentGroup}
          onChange={(e) => {
            updateContentGroup(e.target.value);
          }}
        />
      </div>
    );
  };

  const embedTypeContent = () => {
    return (
      <>
        <div className="setting-items">
          <div className="item-name">Your {getEmbeddingDisplay()} URL</div>
          <input
            type="text"
            id="url"
            className="url-input"
            tabIndex="0"
            placeholder={placeholderMap[embeddingFullType]}
            value={customUrl}
            onChange={(e) => {
              updateUrl(e.target.value);
            }}
          />
        </div>
        {[EmbeddingType.Bot_Auto, EmbeddingType.Bot_AutoImage].includes(embeddingFullType) &&
          setContentGround()}
        {[
          EmbeddingType.Bot_Auto,
          EmbeddingType.Bot_AutoImage,
          EmbeddingType.Bot_Api,
          EmbeddingType.NextGet_AI,
        ].includes(embeddingFullType) && setUsernamePassword()}
      </>
    );
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    setBtn(inactiveBtn);
    setErr(inactiveError);
    if (customUrl) {
      if (checkValidUrl(customUrl)) {
        setBtn(activeBtn);
        setErr(inactiveError);
      } else {
        setBtn(inactiveBtn);
        setErr(activeError);
        setErrorMessage(errorMessageMap[embeddingFullType]);
      }
      // if the url is empty, set the button to inactive, disable the error message
    } else {
      setBtn(inactiveBtn);
      setErr(inactiveError);
    }
  }, [customUrl]);

  const environmentSettingPopup = () => {
    return (
      <div className="content">
        <div className="title">Your Environment</div>
        <div
          className="close-button"
          onClick={() => {
            setIsOpen(false);
          }}
        >
          <span className="material-icons">close</span>
        </div>

        <div className="desc">
          {reminderMessage}
          <a
            href="https://github.com/MicroStrategy/playground#requirements-for-embedding"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              onSendGAEvent(CLICK_PLAYGROUND_USER_MANUAL_LINK);
            }}
          >
            user manual
          </a>
          .
        </div>
        {embedTypeContent()}
        <div className="error-message">
          <p className={err}>{errorMessage}</p>
        </div>
        <button
          type="button"
          className={btn}
          onClick={() => {
            updateEnvironment(embeddingFullType, {
              customUrl,
              username,
              password,
              contentGroup,
            });
            setIsOpen(false);
          }}
        >
          Done
        </button>
      </div>
    );
  };

  return (
    <Modal
      appElement={document.getElementById('root')}
      className="environment-setting"
      overlayClassName="environment-setting-overlay"
      isOpen={isOpen}
      onRequestClose={() => {
        setIsOpen(false);
      }}
    >
      {environmentSettingPopup()}
    </Modal>
  );
};

EnvironmentSetting.propTypes = {
  embeddingType: PropTypes.string.isRequired,
  embeddingFullType: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  updateEnvironment: PropTypes.func.isRequired,
  onSendGAEvent: PropTypes.func.isRequired,
  customUrl: PropTypes.string.isRequired,
  updateUrl: PropTypes.func.isRequired,
  contentGroup: PropTypes.string.isRequired,
  updateContentGroup: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
  updateUsername: PropTypes.func.isRequired,
  password: PropTypes.string.isRequired,
  updatePassword: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    embeddingType: selectEmbeddingMainType(state),
    embeddingFullType: selectEmbeddingFullType(state),
    isOpen: selectIsOpen(state),
    customUrl: selectCustomUrl(state),
    contentGroup: selectContentGroup(state),
    username: selectUserName(state),
    password: selectPassword(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setIsOpen: setIsOpenAction,
      updateEnvironment: updateEnvironmentAction,
      onSendGAEvent: sendGAEvent,
      updateUrl: updateUrlAction,
      updateUsername: updateUsernameAction,
      updatePassword: updatePasswordAction,
      updateContentGroup: updateContentGroupAction,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EnvironmentSetting);
